import { ClassMetrics, SessionMetrics } from '../../components/dashboard/types';
import { ClassStudent } from '../types';

interface SessionMetricObject {
    [key: string]: SessionMetrics
}

export const makeClassMetrics = ({ sessionMetricsObject, students }: { sessionMetricsObject: SessionMetricObject, students: ClassStudent[] }): ClassMetrics => {
    const pluralizedRole = {
        student: 'students',
        teacher: 'teachers',
        assistant: 'assistants'
    };

    const classMetrics = {
        students: {
            talk_time: 0,
            talk_count: 0,
            focus_time: 0,
            focus_count: 0,
            hand_raised_time: 0,
            hand_raised_count: 0,
            feedback_time: 0,
            feedback_count: 0
        },
        teachers: {
            talk_time: 0,
            talk_count: 0,
            focus_time: 0,
            focus_count: 0,
            hand_raised_time: 0,
            hand_raised_count: 0,
            feedback_time: 0,
            feedback_count: 0
        },
        assistants: {
            talk_time: 0,
            talk_count: 0,
            focus_time: 0,
            focus_count: 0,
            hand_raised_time: 0,
            hand_raised_count: 0,
            feedback_time: 0,
            feedback_count: 0
        }
    };

    const sessionIds = Object.keys(sessionMetricsObject);

    sessionIds.forEach(() => {
        const metricValuesForEachSession = Object.values(sessionMetricsObject);

        metricValuesForEachSession.forEach((metricValue) => {
            Object.keys(metricValue).forEach((key) => {
                const student = students.find((_student) => _student.student_id === key);

                if (student) {
                    const value = metricValue[student.student_id];
                    const role = pluralizedRole[student.role];

                    classMetrics[role] = {
                        talk_time: classMetrics[role].talk_time += value.talk_time,
                        talk_count: classMetrics[role].talk_count += value.talk_count,
                        focus_time: classMetrics[role].focus_time += value.focus_time,
                        focus_count: classMetrics[role].focus_count += value.focus_count,
                        hand_raised_time: classMetrics[role].hand_raised_time += value.hand_raised_time,
                        hand_raised_count: classMetrics[role].hand_raised_count += value.hand_raised_count,
                        feedback_time: classMetrics[role].feedback_time += value.feedback_time,
                        feedback_count: classMetrics[role].feedback_count += value.feedback_count
                    };
                }
            });
        });
    });

    const totalSessions = Object.values(sessionMetricsObject).length;

    Object.values(classMetrics).forEach((value) => {
        value.talk_time /= totalSessions;
        value.talk_count /= totalSessions;
        value.focus_time /= totalSessions;
        value.focus_count /= totalSessions;
        value.hand_raised_time /= totalSessions;
        value.hand_raised_count /= totalSessions;
        value.feedback_time /= totalSessions;
        value.feedback_count /= totalSessions;
    });

    return classMetrics;
};
